import controller from './content-header.controller';

const template = require('./content-header.html');

export default {
    bindings: {
        stateTitle: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/content-header/content-header.component.js